<div class="recommend-event-modal">
  <mat-toolbar matDialogTitle class="mat-accent m-0">
    <span class="title dialog-title">{{'event.recommend' | translate}}</span>
    <button mat-button class="mat-icon-button"
            (click)="dialogRef.close()"
            aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar>
  <div class="content">
    <mat-form-field appearance="fill" class="width-100">
      <mat-label>{{ 'event.recommendation_text' | translate }}</mat-label>
      <textarea matInput cdkTextareaAutosize
                #autosize="cdkTextareaAutosize"
                cdkAutosizeMinRows="2"
                cdkAutosizeMaxRows="5"
                [value]="recommendationText()"
                (input)="recommendationText.set(($any($event.target).value))"
      required></textarea>
    </mat-form-field>
  </div>
  <div mat-dialog-actions class="m-0" fxLayout="row" fxLayoutAlign="end center">
    <button
      mat-raised-button
      (click)="createRecommendation()"
      class="save-button mat-accent"
      [disabled]="!recommendationText()">
      {{'event.save' | translate}}
    </button>
  </div>
</div>
